// Rotas das telas de showcase da POC (Cockpit, DRE com variacao, Revisao de
// lancamentos, Copiloto governado). So existem no portal, dado mockado nos
// proprios arquivos em views/showcase. Import no TOPO de pathes.js, longe do
// fim, que e onde a dev apenda rotas.

const meta = {
    redirectHomeIfLogged: false,
    requireAuth: true,
}

export default [
    {
        component: () => import('@/views/showcase/PocCockpitView'),
        meta: { ...meta, title: 'Acompanhamento do Cronograma do Fechamento' },
        name: 'PocCockpit',
        path: '/poc/cockpit',
    },
    {
        component: () => import('@/views/showcase/PocVarianceView'),
        meta: { ...meta, title: 'DRE com explicação de variação' },
        name: 'PocVariance',
        path: '/poc/dre-variacao',
    },
    {
        component: () => import('@/views/showcase/PocEntryReviewView'),
        meta: { ...meta, title: 'Revisão de lançamentos' },
        name: 'PocEntryReview',
        path: '/poc/revisao-lancamentos',
    },
    {
        component: () => import('@/views/showcase/PocProcessDocsView'),
        meta: { ...meta, title: 'Documentação do processo com agentes de IA' },
        name: 'PocProcessDocs',
        path: '/poc/documentacao-processo',
    },
]
